import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import GiftsPage from './pages/GiftsPage';
import RsvpPage from './pages/RsvpPage';
import PhotosPage from './pages/PhotosPage';
import MessagesPage from './pages/MessagesPage';
import LocationPage from './pages/LocationPage';
import ThankYouPage from './pages/ThankYouPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="presentes" element={<GiftsPage />} />
          <Route path="confirmar" element={<RsvpPage />} />
          <Route path="fotos" element={<PhotosPage />} />
          <Route path="mensagens" element={<MessagesPage />} />
          <Route path="local" element={<LocationPage />} />
          <Route path="obrigado" element={<ThankYouPage />} />
          <Route path="admin" element={<AdminPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;